import { BaseFetch } from "../main-model";
export default class EvalFormModel extends BaseFetch {
  getEvalFormBy = (data) =>
    this.authFetch({
      url: "eval-form/getEvalFormBy",
      method: "POST",
      body: data,
    });
  getEvalFormById = (data) =>
    this.authFetch({
      url: "eval-form/getEvalFormById",
      method: "POST",
      body: data,
    });
  insertEvalForm = (data) =>
    this.authFetch({
      url: "eval-form/insertEvalForm",
      method: "POST",
      body: data,
    });
  updateEvalFormById = (data) =>
    this.authFetch({
      url: "eval-form/updateEvalFormById",
      method: "POST",
      body: data,
    });
  deleteEvalFormById = (data) =>
    this.authFetch({
      url: "eval-form/deleteEvalFormById",
      method: "POST",
      body: data,
    });
  getEvalFormByEmployee = (data) =>
    this.authFetch({
      url: "eval-form/getEvalFormByEmployee",
      method: "POST",
      body: data,
    });
  getEvalFormByYear = (data) =>
    this.authFetch({
      url: "eval-form/getEvalFormByYear",
      method: "POST",
      body: data,
    });
}
